import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SouthAfricaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='#06A86E'
			/>
			<mask
				id='mask0_2332_16292'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16292)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 1.8667L6.66667 7.00003L0 12.1334V1.8667Z'
					fill='#FFBF2E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.953125 2.09998L5.47545 6.99998L-0.953125 11.9V2.09998Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.57096 5.6L1.9043 0H19.9995V5.6H8.57096Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.80999 4.66667L3.0957 0H20.0005V4.66667H8.80999Z'
					fill='#F44E46'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M1.9043 14H19.9995V8.40002H8.57096L1.9043 14Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.0957 14H20.0005V9.33337H8.80999L3.0957 14Z'
					fill='#072CB4'
				/>
			</g>
		</svg>
	);
};

export default SouthAfricaFlagIcon;
